import { useState } from 'react';

export default function Features() {
  const [expandedCard, setExpandedCard] = useState(0);

  const features = [
    {
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide.',
      extendedDescription: 'Our advanced encryption protocols ensure that your online activities remain completely private and secure from any third-party interference.',
      image: 'https://public.readdy.ai/ai/img_res/e48cd6d88a9e47f473993cb61638c398.jpg'
    },
    {
      title: 'Global Server Network',
      description: 'Connect to our extensive network of high-speed servers located across the globe for optimal performance.',
      extendedDescription: 'Access content from anywhere with our strategically positioned servers, ensuring fast and reliable connections no matter where you are.',
      image: 'https://readdy.ai/api/search-image?query=Digital%20world%20map%20with%20glowing%20connection%20points%20and%20network%20lines%20connecting%20continents%2C%20illuminated%20server%20locations%20across%20globe%2C%20dark%20blue%20background%20with%20bright%20cyan%20and%20green%20network%20nodes%2C%20global%20connectivity%20visualization%2C%20modern%20tech%20illustration%20showing%20international%20data%20routes%20and%20server%20infrastructure%2C%20clean%20minimalist%20design&width=600&height=800&seq=feature-002&orientation=portrait'
    },
    {
      title: 'Lightning-Fast Speeds',
      description: 'Enjoy seamless browsing, streaming, and downloading without compromising on speed or security.',
      extendedDescription: 'Our optimized infrastructure delivers exceptional performance, allowing you to stream in HD, game online, and browse without any lag.',
      image: 'https://readdy.ai/api/search-image?query=Dynamic%20speed%20visualization%20with%20glowing%20motion%20trails%20and%20velocity%20lines%2C%20abstract%20representation%20of%20fast%20data%20transfer%20with%20bright%20streaks%20of%20light%2C%20speedometer%20and%20performance%20indicators%2C%20dark%20background%20with%20vibrant%20cyan%20and%20green%20speed%20effects%2C%20modern%20tech%20aesthetic%20showing%20rapid%20connectivity%20and%20bandwidth%2C%20sleek%20futuristic%20design&width=600&height=800&seq=feature-003&orientation=portrait'
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <h2 className="text-5xl font-bold text-gray-900 text-center mb-4">
          VPN Features 🔒
        </h2>
        <div className="h-16"></div>

        <div className="grid grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
                expandedCard === index ? 'col-span-2' : 'col-span-1'
              }`}
              style={{ aspectRatio: '3/4' }}
              onMouseEnter={() => setExpandedCard(index)}
            >
              <div className="w-full h-full">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <h3 className="text-3xl font-bold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-base text-white/90 leading-relaxed">
                  {feature.description}
                </p>
                {expandedCard === index && (
                  <p className="text-base text-white/80 leading-relaxed mt-3">
                    {feature.extendedDescription}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
